export var COLUMN_CONTENT_JUSTIFY;
(function (COLUMN_CONTENT_JUSTIFY) {
    COLUMN_CONTENT_JUSTIFY[COLUMN_CONTENT_JUSTIFY["start"] = 0] = "start";
    COLUMN_CONTENT_JUSTIFY[COLUMN_CONTENT_JUSTIFY["end"] = 1] = "end";
})(COLUMN_CONTENT_JUSTIFY || (COLUMN_CONTENT_JUSTIFY = {}));
//# sourceMappingURL=GridCore.public.js.map